/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { useMemo } from 'react';
import { useAutomationLimitBannerState } from '../store/index.tsx';
import { BANNER_NAME } from '../../common/constants.tsx';
import { useStandardAutomationLimitAwarenessExperiment } from '../../services/use-experiment/index.tsx';

export const useBannerAutomationLimitAwareness = () => {
	const state = useAutomationLimitBannerState();
	const { isEligible, cohort, projectType, bannerType } =
		useStandardAutomationLimitAwarenessExperiment();

	const isEnabled = Boolean(
		isEligible &&
			projectType &&
			bannerType &&
			cohort !== 'not-enrolled' &&
			!state[projectType].isDismissed &&
			!state[projectType].isLoading,
	);

	return useMemo(
		() => ({
			isEnabled,
			name: BANNER_NAME as string,
			height: isEnabled && projectType && cohort === 'treatment' ? state[projectType].height : 0,
		}),
		[isEnabled, cohort, state, projectType],
	);
};
